export default "__VITE_ASSET__f8b8fcb2__"